"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokens = void 0;
var tokens = {
  persistence: {
    NONE: 'NONE',
    LOCAL: 'LOCAL',
    SESSION: 'SESSION'
  }
};
exports.tokens = tokens;